export default __webpack_public_path__ + "static/media/missed-each-other.c73db96c.gif";